import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-in-game-options',
  templateUrl: './in-game-options.component.html',
  styleUrls: ['./in-game-options.component.scss']
})
export class InGameOptionsComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: {onWatch: any, onJoin: any}) { }

  ngOnInit(): void {
  }

  justWatch(){
    return this.data.onWatch();
  }

  joinTeam(){
    return this.data.onJoin();
  }

}
